var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 192,
    viewBox: "0 0 171 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 192,
    rx: 30,
    fill: "#EBEBEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.8914,
    cy: 72.6414,
    r: 17.6414,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.781 134.173C123.781 129.198 122.801 124.27 120.897 119.673C118.993 115.076 116.202 110.899 112.684 107.381C109.165 103.862 104.988 101.071 100.391 99.167C95.7938 97.2628 90.8666 96.2827 85.8907 96.2827C80.9148 96.2827 75.9877 97.2628 71.3906 99.167C66.7935 101.071 62.6164 103.862 59.0979 107.381C55.5795 110.899 52.7884 115.076 50.8843 119.673C48.9801 124.27 48 129.198 48 134.173L85.8907 134.173H123.781Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a8231d60784f4e977ffa615e0034e372.svg";
export { ForwardRef as ReactComponent };